<template>
    <div>
    <div v-if="getShowModalMessageResult">{{processModalResult()}}</div>
    <div v-if="getAxiosRefresh == 3">{{initData()}}</div>
    <div v-if="getTaskPreparedEdit>-1">{{prepareEdit(getTaskPreparedEdit)}}</div>
    <div v-if="getConsoleGrade">{{setGrade()}}</div>

    <v-layout row wrap v-if="getAxiosRefresh == -1 && myContent">
        <v-expansion-panels
                v-model="panels"
                multiple
                flat
                class="px-6"
            >
        <v-expansion-panel>
            <v-expansion-panel-header><b>Assignment</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-flex xs12>                 
                <v-layout row wrap>               
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden read-only--background read-only--border-color', 
                                (getTaskVertic == true) ? 'rounded-tl-lg rounded-tr-lg':'rounded-tl-lg rounded-bl-lg']">

                            <div v-if="myContent.languages[getShowTaskIndex].permissions && !myContent.islocked" class="universal-row-item__group-btn-panel read-only--border-color">
                                <div class="lang-side">
                                    <img class="lang-side__img" :src="getLanguageIcons[getShowTaskIndex].url" />
                                </div>
                                <v-icon @click="prepareEdit(getShowTaskIndex)" dense>edit</v-icon>
                                <v-icon @click ="clearTranslation(getShowTaskIndex)" dense>delete</v-icon>                                
                                <v-icon v-if="myContent.languages[getShowTaskIndex].visible == 0" @click="changeVisibility(getShowTaskIndex)" dense>visibility_off</v-icon>                                       
                                <v-icon v-else @click="changeVisibility(getShowTaskIndex)" dense>visibility</v-icon>  
                                <v-icon class="border-l read-only--border-color" @click="$store.commit('setShowTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                            </div>   
                            <div class="ma-2 px-2 py-3 border-b read-only--border-color">
                                <b>{{JSON.parse(myContent.languages[getShowTaskIndex].content).title}} </b>
                            </div>                 
                            <v-card-text>
                                <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).assignment" class="pa-2"></div>
                            </v-card-text>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden', 
                                (getShowTaskIndex > -1 && getTaskVertic == false) ? 'border-l-none rounded-tr-lg rounded-br-lg':'', 
                                (getShowTaskIndex > -1 && getTaskVertic == true) ? 'border-t-none rounded-br-lg rounded-bl-lg':'', 
                                (getShowTaskIndex > -1) ? '':'rounded-lg']">

                        <div class="universal-row-item__group-btn-panel">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getEditTaskIndex].url" />
                            </div>

                            <v-menu v-if="getShowTaskIndex > -1" class="lang-wrapper" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none" title="copy parts" dense>
                                    content_copy
                                    </v-icon>
                                </template>
                                    <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(copy, index) in copies" :key="index" @click="copyContent(copy.list)"> 
                                            <v-list-item-title>{{copy.name}}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                    </v-list>
                                </v-menu> 
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" dense>save</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" dense>check_circle</v-icon>
                            <v-icon title="close without save" @click="closeTask()" dense>meeting_room</v-icon>
                            
                            <v-icon class="border-l" @click="$store.commit('setEditTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                        </div>
                        <div class="pa-2">
                            <v-text-field
                                label="Title"
                                v-model = "tmpTitle"                                
                            ></v-text-field>
                            <quill-editor v-model='tmpAssignment' :options="getEditorOption()" />
                        </div>
                    </v-flex>                    
                </v-layout>
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>        

        <v-expansion-panel>
            <v-expansion-panel-header><b>Program file(s)</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-expansion-panels         
                    v-model="panels1"
                    multiple
                    flat
                >
                    <v-expansion-panel v-if="objectChangePermission">
                        <v-expansion-panel-header>File list</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-tabs                                
                                center-active 
                                color="blue" slider-color="blue"   
                                class="customTabTitle"                 
                                >
                                <v-icon @click="addElement(1)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(file, _index) in getFileNamesClear(1)" :key="_index"> 
                                    {{file.name}} &nbsp;
                                    <v-icon small @click="editTab(1,file.index)" class="ml-2 color--medium-emphasis">mdi-pencil</v-icon>
                                    <v-icon v-if="file.index>0" small @click="tryDeleteElement(1,file.index)" class="color--medium-emphasis">mdi-delete</v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                    v-if="editNo == 1"
                                    label="Change name (and press Enter)"
                                    v-model="chanName.name"
                                    @keydown.enter.prevent="changeTabName(1)"
                                    @keydown.esc.prevent="editNo = 0"
                            ></v-text-field>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Requested file(s)</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap>                      
                                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                                        <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                                <v-tab v-for="(file, _index) in getFileNamesClear(1)" :key="_index" @click="fileIndex11 = file.index"> 
                                                    {{file.name}} &nbsp;
                                                </v-tab>
                                            </v-tabs>
                                            <codemirror v-if="fileIndex11 < JSON.parse(myContent.languages[getShowTaskIndex].content).files.length" 
                                                :value="JSON.parse(myContent.languages[getShowTaskIndex].content).files[fileIndex11].rContent" :options="getCmOptions(editorType, true) " />
                                            <div v-else> -- not defined --</div>
                                        </div>
                                </v-flex>
                                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                                        <v-card-text>
                                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                                <v-tab v-for="(file, _index) in getFileNamesClear(1)" :key="_index" @click="fileIndex12 = file.index"> 
                                                    {{file.name}} &nbsp;
                                                </v-tab>
                                            </v-tabs>
                                            <codemirror v-model="programFilesRequestedEdit[fileIndex12]" :options="getCmOptions(editorType, false)" />
                                        </v-card-text>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                        <v-expansion-panel-header>Author solution</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-layout row wrap>                      
                                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">                            
                                    <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                                        <v-toolbar class="main-toolbar main-toolbar--slim" >                                                                     
                                            <v-spacer></v-spacer>
                                            <v-btn class="score-preview-box" outlined>{{grade[0]}}%</v-btn>

<!--                                             <div class="icon-wrapper" @click="showCompileInfo[0] = !showCompileInfo[0]"><v-icon :color="getCompilerColor(0)" class="own-icon">build</v-icon></div>
                                            <div class="icon-wrapper" @click="showExecuteInfo[0] = !showExecuteInfo[0]"><v-icon :color="getResultColor(0)" class="own-icon">reorder</v-icon></div>
 -->                                            <div class="icon-wrapper" @click="runCode(0,1)"><v-icon color="green" class="own-icon" title="run">play_arrow</v-icon></div>
                                            <div class="icon-wrapper" @click="runCode(0,0)"><v-icon color="green" class="own-icon" title="execute">check_circle_outline</v-icon></div>
                                        </v-toolbar>
                                        <v-card>                                            
                                            <v-card-text>
                                                <VueTerm v-bind:terminalIndex="1"/>
                                            </v-card-text>
                                        </v-card>
                                        <v-card-text>                            
                                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                                <v-tab v-for="(file, _index) in getFileNamesClear(1)" :key="_index" @click="fileIndex21 = file.index"> 
                                                    {{file.name}} &nbsp;
                                                </v-tab>
                                            </v-tabs>
                                            <codemirror v-if="fileIndex21 < JSON.parse(myContent.languages[getShowTaskIndex].content).files.length" :value="JSON.parse(myContent.languages[getShowTaskIndex].content).files[fileIndex21].aContent" :options="getCmOptions(editorType, true) " />
                                            <div v-else> -- not defined --</div>
                                        </v-card-text>
                                    </div>
                                </v-flex>
                                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2"> 
                                    <div class="pa-2 fill-height">                            
                                        <v-toolbar class="main-toolbar main-toolbar--slim" >                                                
                                            <v-spacer></v-spacer>
                                            <v-btn class="score-preview-box" outlined>{{grade[1]}}%</v-btn>  

                                            <!-- <v-icon @click="showCompileInfo[1] = !showCompileInfo[1]" :color="getCompilerColor(1)" style="margin:5px;">build</v-icon> 
                                            <div class="icon-wrapper" @click="showCompileInfo[1] = !showCompileInfo[1]"><v-icon :color="getCompilerColor(1)" class="own-icon">build</v-icon></div>
                                            <div class="icon-wrapper" @click="showExecuteInfo[1] = !showExecuteInfo[1]"><v-icon :color="getResultColor(1)" class="own-icon">reorder</v-icon></div> -->
                                            <div class="icon-wrapper" @click="runCode(1,1)"><v-icon color="green" class="own-icon" title="run">play_arrow</v-icon></div>
                                            <div class="icon-wrapper" @click="runCode(1,0)"><v-icon color="green" class="own-icon" title="execute">check_circle_outline</v-icon></div>   
                                        </v-toolbar>
                                        <v-card>                                            
                                            <v-card-text>
                                                <VueTerm v-bind:terminalIndex="2"/>
                                            </v-card-text>
                                        </v-card>

<!--                                         <v-card v-if="vplProcessInfo[1]>''">
                                            <v-card-text> {{vplProcessInfo[1]}}</v-card-text>     
                                        </v-card>
                                        <v-card v-if="showCompileInfo[1]">
                                            <v-card-text> <span v-html="vplCompilerInfo[1]"></span> </v-card-text>     
                                        </v-card>
                                        <v-card v-if="showExecuteInfo[1]">
                                            <v-card-text><span v-html="vplExecutionInfo[1]"></span> </v-card-text>     
                                        </v-card>                                        
 -->                                        <v-card-text>                            
                                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                                <v-tab v-for="(file, _index) in getFileNamesClear(1)" :key="_index" @click="fileIndex22 = file.index"> 
                                                    {{file.name}} &nbsp;
                                                </v-tab>
                                            </v-tabs>
                                            <codemirror v-model="programFilesAuthoredEdit[fileIndex22]" :options="getCmOptions(editorType, false)" />
                                        </v-card-text>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-expansion-panel-content>
        </v-expansion-panel>
        
        <v-expansion-panel v-if="myContent.task_type_id == 8">
            <v-expansion-panel-header><b>Test cases</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>                      
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                        <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                            <codemirror v-model="JSON.parse(myContent.languages[getShowTaskIndex].content).testCases" :options="getCmOptions(editorType, true)" />
                        </div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <div class="pa-2 fill-height">  
                                <codemirror v-model="tmpTestCases" :options="getCmOptions(editorType, false)" />
                        </div>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="myContent.task_type_id == 9 || myContent.task_type_id == 10">
            <v-expansion-panel-header><b>Config file(s)</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-expansion-panels v-model="panels3" multiple flat>
                    <v-expansion-panel v-if="objectChangePermission">
                        <v-expansion-panel-header>File list</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-tabs v-if="objectChangePermission" center-active color="blue" slider-color="blue" class="customTabTitle">
                                <v-icon @click="addElement(3)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(file, _index) in getFileNamesClear(3)" :key="_index"> 
                                    {{file.name}} &nbsp;
                                    <v-icon small @click="editTab(3,file.index)" class="ml-2 color--medium-emphasis">mdi-pencil</v-icon>
                                    <v-icon v-if="file.index>0" small @click="tryDeleteElement(3,file.index)" class="color--medium-emphasis">mdi-delete</v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                    v-if="editNo == 3"
                                    label="Change name (and press Enter)"
                                    v-model="chanName.name"
                                    @keydown.enter.prevent="changeTabName(3)"
                                    @keydown.esc.prevent="editNo = 0"
                                ></v-text-field>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-layout row wrap>                      
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                        <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                <v-tab v-for="(file, _index) in getFileNamesClear(3)" :key="_index" @click="fileIndex41 = file.index"> 
                                    {{file.name}} &nbsp;
                                </v-tab>
                            </v-tabs>
                            <codemirror v-if="fileIndex41 < JSON.parse(myContent.languages[getShowTaskIndex].content).configFiles.length" :value="JSON.parse(myContent.languages[getShowTaskIndex].content).configFiles[fileIndex41]" :options="getCmOptions(editorType, true)"/>
                            <div v-else> -- not defined --</div>
                        </div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <div class="pa-2 fill-height">
                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                <v-tab v-for="(file, _index) in getFileNamesClear(3)" :key="_index" @click="fileIndex42 = file.index"> 
                                    {{file.name}} &nbsp;
                                </v-tab>
                            </v-tabs>
                            <codemirror v-model="configFilesEdit[fileIndex42]" :options="getCmOptions(editorType, false)" />                      
                        </div>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header><b>Data file(s)</b></v-expansion-panel-header>            
            <v-expansion-panel-content>
                <v-expansion-panels v-model="panels2" multiple flat>
                    <v-expansion-panel v-if="objectChangePermission">
                        <v-expansion-panel-header>Data file list</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <v-tabs
                                v-if="objectChangePermission"
                                center-active 
                                color="blue" slider-color="blue"   
                                class="customTabTitle"                 
                                >
                                <v-icon @click="addElement(2)">mdi-plus-circle-outline</v-icon>
                                <v-tab v-for="(file, _index) in getFileNamesClear(2)" :key="_index" > 
                                    {{file.name}} &nbsp;
                                    <v-icon small @click="editTab(2,file.index)" class="ml-2 color--medium-emphasis">mdi-pencil</v-icon>
                                    <v-icon v-if="file.index>0" small @click="tryDeleteElement(2,file.index)" class="color--medium-emphasis">mdi-delete</v-icon>
                                </v-tab>
                            </v-tabs>
                            <v-text-field
                                    v-if="editNo == 2"
                                    label="Change name (and press Enter)"
                                    v-model="chanName.name"
                                    @keydown.enter.prevent="changeTabName(2)"
                                    @keydown.esc.prevent="editNo = 0"
                                ></v-text-field>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-layout row wrap>                      
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                        <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                <v-tab v-for="(file, _index) in getFileNamesClear(2)" :key="_index" @click="fileIndex31 = file.index"> 
                                    {{file.name}} &nbsp;
                                </v-tab>
                            </v-tabs>
                            <codemirror v-if="fileIndex31 < JSON.parse(myContent.languages[getShowTaskIndex].content).filesToKeep.length" :value="JSON.parse(myContent.languages[getShowTaskIndex].content).filesToKeep[fileIndex31]" :options="getCmOptions(editorType,true) " />
                            <div v-else> -- not defined --</div>
                        </div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <div class="pa-2 fill-height">  
                            <v-tabs center-active color="blue" slider-color="blue" class="customTabTitle">
                                <v-tab v-for="(file, _index) in getFileNamesClear(2)" :key="_index" @click="fileIndex32 = file.index"> 
                                    {{file.name}} &nbsp;
                                </v-tab>
                            </v-tabs>
                            <codemirror v-model="dataFilesEdit[fileIndex32]" :options="getCmOptions(editorType,false)" />                                                      
                        </div>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header><b>Help</b></v-expansion-panel-header>
            <v-expansion-panel-content>            
            <v-layout row wrap>                      
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                    <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).help" class="read-only--background border-all read-only--border-color pa-2 fill-height"></div>
                </v-flex>
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                    <quill-editor v-model='tmpHelp' :options="getEditorOption()" />                        
                </v-flex>
            </v-layout>                        
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>            
            <v-expansion-panel-header><b>Settings</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>
                    <v-flex xs1>                                                        
                        <v-text-field
                            v-model="myContent.max_score"
                            label="Max score:"
                            outlined
                            :rules="[rules.required, rules.content, rules.size]"
                            :readonly = "!objectChangePermission"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs6>  </v-flex>
                    <v-flex xs4 v-if="objectChangePermission"> 
                        <v-layout row justify-end>                                               
                            <v-menu class="lang-wrapper" top>                        
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                                <v-btn class="background-transparent card-custom-button shadow-none">
                                    <v-icon class="mr-3 pr-3 border-r" dense>
                                        {{task_icons[myContent.task_type_id-1].icon}}                             
                                    </v-icon>
                                    {{task_icons[myContent.task_type_id-1].descr}}  
                                </v-btn>    
                                </div>                                               
                            </template>
                                <v-list dense>
                                <v-list-item-group>
                                    <v-list-item @click="myContent.task_type_id = 8">
                                        <v-icon style="margin-right:3px">{{task_icons[7].icon}}</v-icon><v-list-item-title v-text="task_icons[7].descr"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="myContent.task_type_id = 9">
                                        <v-icon style="margin-right:3px">{{task_icons[8].icon}}</v-icon><v-list-item-title v-text="task_icons[8].descr"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="myContent.task_type_id = 10">
                                        <v-icon style="margin-right:3px">{{task_icons[9].icon}}</v-icon><v-list-item-title v-text="task_icons[9].descr"></v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                                </v-list>
                            </v-menu>                              
                        </v-layout>
                    </v-flex>
                </v-layout>               
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels> 
        </v-layout>

        <v-layout v-if="myContent && getEditTaskIndex>-1" class="d-flex align-end flex-column border-t mt-5 pa-2">
            <div class="btn-group-a">
                <img class="btn-group-a__divider-item" :src="getLanguageIcons[getEditTaskIndex].url" width="20" />
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--green" dense>save</v-icon>
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--blue" dense>check_circle</v-icon>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import * as es from '../../../../assets/editor_settings.js'
import axios from '../../../../axios-auth'
import * as icn from '../../../../assets/task_icons.js'
import * as misc from '../../../../assets/misc.js'
import VueTerm from '../../../vue_term/vueterm.vue'

export default {
    data() {
        return {
                myContent: null,
                myGlobals: null,
                task_icons: [],
                tmpTitle: '',
                tmpAssignment: '',
                tmpHelp: '',
                tmpTestCases: '',

                programFileNames: [],
                dataFileNames: [],
                configFileNames: [],
                programFilesRequestedEdit: [],
                programFilesAuthoredEdit: [],
                dataFilesEdit: [],
                configFilesEdit: [],

                fileStatus: [],
                fileIndex11: 0, // requested
                fileIndex21: 0, // authors
                fileIndex12: 0, // requested
                fileIndex22: 0, // authors
                fileIndex31: 0, // data
                fileIndex32: 0, // data
                fileIndex41: 0, // config
                fileIndex42: 0, // config
                editNo: 0, // edit for change name
                chanName: {name:'', index:0}, // model for renaming
                deleteTab: -1,
                deleteIndex: -1,
                rules: {
                    required: value => !!value || 'Required.',
                    size: value => value > 0 && value < 1000 || 'Out of size.',
                    content: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Invalid value.'
                    }
                },
                copies: [ { name: 'all', list: ['assignment','requested','author','test cases','data files','config files','help'] }, // menu content}
                          { name: 'assignment', list: ['assignment'] }, // menu content
                          { name: 'requested files', list: ['requested'] },
                          { name: 'author solutions', list: ['author'] },
                          { name: 'test cases', list: ['test cases'] },
                          { name: 'data files', list: ['data files'] },
                          { name: 'config files', list: ['config files'] },
                          { name: 'help', list: ['help'] },
                ],
                panels : [0],
                panels1 : [0],
                panels2 : [0],
                panels3 : [0],
                defaultExtension : '',
                editorType : '',

              /*  showCompileInfo: [false,false],
                showExecuteInfo: [false,false],
                monitoringSocket: [null,null],
             */   isRunning: [false,false],
             
                grade: [0,0],

               // vplProcessInfo: ['',''],
               // vplCompilerInfo: ['',''],
               // vplExecutionInfo: ['',''],

              }
    },
    props: {
        my_element: Object, 
        objectChangePermission : Boolean
    },
    computed: 
            mapGetters([
                        'getLanguageIcons',
                        'getCountdownStatus',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskPreparedEdit',
                        'getShowModalMessageResult',
                        'getAxiosRefresh',
                        'getConsoleGrade'
                        ])
    ,
    components: {
        quillEditor,
        codemirror,
        VueTerm
    },
    mounted() {
        if (this.getAxiosRefresh !=3 ) this.initData()
    },
    methods: {
        // ************ main methods
        getEditorOption(_version) { return es.getEditorOption(_version) },
        getCmOptions(_editorType,_readOnly) { 
            if(_readOnly) return Object.assign(es.getCmOptions(_editorType,_readOnly), {theme: "solarized light"});
            else return es.getCmOptions(_editorType,_readOnly); 
        },  
        changeVisibility(_index) {
            this.$store.commit('setTaskNewVisibility', 1 - this.myContent.languages[_index].visible)
            this.$store.commit('setTaskChangeVisibility', true)
            this.myContent.languages[_index].visible = 1 - this.myContent.languages[_index].visible                   
        },
        prepareEdit(_index) {  
            this.$store.commit('setTaskPreparedEdit',-1)  
            if (!this.myContent.languages[_index].permissions || this.myContent.islocked) return
            this.$store.commit('setEditTaskIndex', _index)
            this.prepareEditTask()
        },
        closeTask() { this.$router.go(-1) },

        // ******** end of main methods
        // *********************************

        initData() {
            // this.$store.commit('setFeedback', null)
            this.$store.commit('setAxiosRefresh',-1)
            this.myContent = this.my_element
            this.task_icons = icn.getIcons()
            // set data in editors by setting in tabs
            this.fileIndex11 = 0
            this.fileIndex21 = 0
            this.fileIndex12 = 0
            this.fileIndex22 = 0
            this.fileIndex31 = 0
            this.fileIndex32 = 0
            this.fileIndex41 = 0
            this.fileIndex42 = 0
            this.fileStatus = [[],[],[],[]]
            this.fileStatus[0].push(0)

            const _glob = misc.getFromJSON(this.myContent.globals,'')
            if (_glob != '') {
                this.programFileNames = _glob.files.files
                this.dataFileNames = _glob.files.filesToKeep
                this.configFileNames = _glob.files.configFiles
                this.programFileNames.forEach(() => {this.fileStatus[1].push(0)});
                this.dataFileNames.forEach(() => {this.fileStatus[2].push(0)});
                this.configFileNames.forEach(() => {this.fileStatus[3].push(0)});
            } 
            
            if (this.getEditTaskIndex > -1 && (!this.myContent.languages[this.getEditTaskIndex].permissions || this.myContent.islocked)) {
                this.$store.commit('setEditTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
            }
            if (this.getShowTaskIndex == this.getEditTaskIndex) {
                this.$store.commit('setShowTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
                this.prepareEdit(this.getEditTaskIndex)
            }                  
            this.getEnvironmentSettings()
        },
        prepareEmptyTask() {
            this.tmpTitle = ''
            this.tmpAssignment = ''
            this.tmpHelp = ''
            this.tmpTestCases = ''
            this.fileStatus = [[],[],[],[]]

            this.fileStatus[0].push(0)
            this.fileStatus[1].push(0)
            this.fileStatus[2].push(0)
            this.programFilesRequestedEdit.push('')
            this.programFilesAuthoredEdit.push('')
            
            this.dataFileNames.push('data1.txt')
            this.dataFilesEdit.push('')
            if (this.$route.params.id_type == 10) {
                this.programFileNames.push('answer.sql')  
                this.configFileNames.push('vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh', 'createTables.sql', 'showResult.sql','correctAnswer.sql', 'dataset1.sql', 'dataset2.sql', 'dataset3.sql')
                this.configFilesEdit.push('','','', '', '','', '', '', '')
                this.fileStatus[3].push(0,0,0,0,0,0,0,0,0)                        
            } else {
                this.programFileNames.push('file1.' + this.defaultExtension)  
                this.configFileNames.push('vpl_run.sh','vpl_debug.sh','vpl_evaluate.sh')
                this.configFilesEdit.push('','','')
                this.fileStatus[3].push(0,0,0)
            }
        },
        getEnvironmentSettings() {
            axios.get('/get-vpl-course-info/' + this.myContent.course_id, this.$store.getters.getAxiosConfig )
            .then(res => {
                this.defaultExtension = res.data.extension
                this.editorType = res.data.editorType
                if (this.$route.params.id == 0) {
                    this.myContent.max_score = 20
                    this.prepareEmptyTask()
                } else {
                    this.prepareEditTask()
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
        prepareEditTask() {
            if (this.getEditTaskIndex == -1) return            
            this.programFilesRequestedEdit = []
            this.programFilesAuthoredEdit = []
            this.configFilesEdit = []
            this.dataFilesEdit = []

            const _content = misc.getFromJSON(this.myContent.languages[this.getEditTaskIndex].content,'')
            if (_content.length == 0) {
                this.tmpTitle = ''
                this.tmpAssignment = ''
                this.tmpHelp = ''
                this.tmpTestCases = ''
                for(let i = 0; i < this.fileStatus[1].length; i++) {
                    this.programFilesRequestedEdit.push('')
                    this.programFilesAuthoredEdit.push('')                
                }          
                for(let i = 0; i < this.fileStatus[2].length; i++) 
                    this.dataFilesEdit.push('')
                for(let i = 0; i < this.fileStatus[3].length; i++) 
                    this.configFilesEdit.push('')
                return
            } 

            this.tmpTitle = _content.title
            this.tmpAssignment = _content.assignment
            this.tmpHelp = _content.help
            this.tmpTestCases = _content.testCases

            for(let i = 0; i < this.programFileNames.length; i++) {
                this.programFilesRequestedEdit.push(_content.files[i].rContent)
                this.programFilesAuthoredEdit.push(_content.files[i].aContent)                
            }
            for(let i = this.programFileNames.length; i < this.fileStatus[1].length; i++) {
                this.programFilesRequestedEdit.push('')
                this.programFilesAuthoredEdit.push('')                
            }
            for(let i = 0; i < this.dataFileNames.length; i++) {
                this.dataFilesEdit.push(_content.filesToKeep[i])
            }
            for(let i = this.dataFileNames.length; i < this.fileStatus[2].length; i++) {
                this.dataFilesEdit.push('')
            }
            for(let i = 0; i < this.configFileNames.length; i++) {
                this.configFilesEdit.push(_content.configFiles[i])
            }
            for(let i = this.configFileNames.length; i < this.fileStatus[3].length; i++) {
                this.configFilesEdit.push('')
            }
        },
        //******************************************************* */
        //******************************************************* */

        copyContent(_list) {
            if (this.getShowTaskIndex > -1) {
                const _json = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_json != '') {
                    if (_list.includes('assignment')) {
                        this.tmpTitle = _json.title
                        this.tmpAssignment = _json.assignment
                    }
                    if (_list.includes('help')) this.tmpHelp = _json.help
                    if (_list.includes('test cases')) {
                        this.tmpTestCases = _json.testCases
                    }
                    if (_list.includes('requested')) {
                        for(let i = 0; i < _json.files.length; i++) {
                            this.programFilesRequestedEdit[i] = _json.files[i].rContent
                        }
                    }
                    if (_list.includes('author')) {
                        for(let i = 0; i < _json.files.length; i++) {
                            this.programFilesAuthoredEdit[i] = _json.files[i].aContent
                        }
                    }
                    if (_list.includes('data files')) {
                        for(let i = 0; i < _json.filesToKeep.length; i++) {
                            this.dataFilesEdit[i] = _json.filesToKeep[i]
                        }
                    }
                    if (_list.includes('config files')) {
                        for(let i = 0; i < _json.configFiles.length; i++) {
                            this.configFilesEdit[i] = _json.configFiles[i]
                        }
                    }
                }              
            }
        },
        saveData(_close, _index, _only_translation) { 
          if (this.myContent.id == 0 && (this.myContent.course_id === undefined || this.myContent.lesson_id === undefined)) {
              this.$store.commit('setFeedback', 'Data about course and/or lesson is missing')
              return
          }
          this.myContent.max_score = isNaN(this.myContent.max_score) ? 20 : this.myContent.max_score

          const _content = {
              title: this.tmpTitle,
              assignment: this.tmpAssignment,
              files: this.getReqAuthFiles(), 
              testCases : this.tmpTestCases,
              filesToKeep: this.dataFilesEdit,
              configFiles: this.configFilesEdit,
              help: this.tmpHelp,
          }
          const _globals = {
              files : {
                files : this.prepareFileList(1,this.programFileNames),
                filesToKeep: this.prepareFileList(2,this.dataFileNames),
                configFiles: this.prepareFileList(3,this.configFileNames)
              }
          }
          const _data = {
            task_id: this.myContent.id,
            course_id: this.myContent.course_id, // will be checked on backend
            lesson_id: this.myContent.lesson_id,
            task_type: 'P',
            task_type_id: this.myContent.task_type_id,
            max_score: this.myContent.max_score,
            content: JSON.stringify(_content), // new data
            globals: JSON.stringify(_globals),
            lang_id: _index + 1,
            only_translation: _only_translation,
            fileStatus: JSON.stringify(this.fileStatus)
          }

        axios.post('/edit-task', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            } 

            if (this.myContent.id == 0 || this.myContent.task_type_id != this.$route.params.id_type) { // new - refresh                  
                if (this.myContent.id == 0) 
                   this.myContent.id = res.data.task_id
                this.$store.commit('setShowTaskIndex', _index)
                this.$store.commit('setEditTaskIndex', _index)
                this.$router.replace({name:'task_edit', params: {
                    id: this.myContent.id,
                    id_type: this.myContent.task_type_id, 
                    show_lang: _index + 1, 
                    edit_lang: _index + 1, 
                    course_id: this.myContent.course_id, 
                    lesson_id: this.myContent.lesson_id
                }})
            } 

            if (_close) this.closeTask()   
            this.$store.commit('setAxiosRefresh', 1)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
        },
        getReqAuthFiles() {
          const _res = []
          for(let i=0; i<this.programFileNames.length; i++) {
            _res.push({rContent:this.programFilesRequestedEdit[i],
                       aContent:this.programFilesAuthoredEdit[i]})
          }
          return _res
        },
        prepareFileList(_status,_list) {
            const _res = []
            for(let i = 0; i < _list.length; i++) {
                if (this.fileStatus[_status][i] != 2) {
                    _res.push(_list[i])
                }
            }
            return _res            
        },
        editTab(tab, index) {
            this.editNo = tab
            switch (tab) {
                case 1 : this.chanName.name = this.programFileNames[index]
                         break                        
                case 2 : this.chanName.name = this.dataFileNames[index]
                         break                        
                case 3 : this.chanName.name = this.configFileNames[index]
                         break                        
            }
            this.chanName.index = index                         
        },
        changeTabName(tab) {
            this.editNo = 0
            switch (tab) {
                case 1 : this.programFileNames[this.chanName.index] = this.chanName.name
                         break                        
                case 2 : this.dataFileNames[this.chanName.index] = this.chanName.name
                         break                        
                case 3 : this.configFileNames[this.chanName.index] = this.chanName.name
                         break                        
            }
        }, 
        addElement(tab) {
            var i = 1
            switch (tab) {
                case 1 : while (this.programFileNames.indexOf("file" + i + '.' + this.defaultExtension) > -1) i++ 
                         this.programFileNames.push("file" + i + '.' + this.defaultExtension)
                         this.programFilesRequestedEdit.push('')
                         this.programFilesAuthoredEdit.push('')
                         break
                case 2 : while (this.dataFileNames.indexOf("data" + i + '.txt') > -1) i++ 
                         this.dataFileNames.push("data" + i + '.txt')
                         this.dataFilesEdit.push('')                         
                         break
                case 3 : while (this.configFileNames.indexOf("config" + i + '.txt') > -1) i++ 
                         this.configFileNames.push("config" + i + '.txt')
                         this.configFilesEdit.push('')                         
                         break
            }
            this.fileStatus[tab].push(1)
        },
        tryDeleteElement(tab,index) {
            this.deleteTab = tab
            this.deleteIndex = index
            if (this.fileStatus[tab][index] != 1) {
                this.$store.commit('setShowModalMessage',
                    {content: 'Are you sure?<br/>You want to delete file? <br /> You will delete files in ALL languages', type: 'warning', 
                    buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
            } else {
                this.deleteElement()
            }
        },
        processModalResult() {            
            const res = this.getShowModalMessageResult
            this.$store.commit('setShowModalMessageResult',null)
            if (res == 2) this.deleteElement()        
        },
        deleteElement() {
            if (this.fileStatus[this.deleteTab][this.deleteIndex] == 1) {
                switch (this.deleteTab) {
                    case 1 : 
                            if (this.fileIndex11 == this.programFileNames.length - 1) 
                                this.fileIndex11 = this.deleteIndex - 1
                            if (this.fileIndex21 == this.programFileNames.length - 1) 
                                this.fileIndex21 = this.deleteIndex - 1                                
                            if (this.fileIndex12 == this.programFileNames.length - 1) 
                                this.fileIndex12 = this.deleteIndex - 1
                            if (this.fileIndex22 == this.programFileNames.length - 1) 
                                this.fileIndex22 = this.deleteIndex - 1                                
                            
                            this.programFileNames.splice(this.deleteIndex,1)
                            this.programFilesRequestedEdit.splice(this.deleteIndex,1)
                            this.programFilesAuthoredEdit.splice(this.deleteIndex,1)
                         break                        
                    case 2 : 
                            if (this.fileIndex31 == this.dataFileNames.length - 1) 
                                this.fileIndex31 = this.deleteIndex - 1
                            if (this.fileIndex32 == this.dataFileNames.length - 1) 
                                this.fileIndex32 = this.deleteIndex - 1
                            this.dataFileNames.splice(this.deleteIndex,1)
                            this.dataFilesEdit.splice(this.deleteIndex,1)
                         break                        
                    case 3 : 
                            if (this.fileIndex41 == this.configFileNames.length - 1) 
                                this.fileIndex41 = this.deleteIndex - 1
                            if (this.fileIndex42 == this.configFileNames.length - 1) 
                                this.fileIndex42 = this.deleteIndex - 1
                            this.configFileNames.splice(this.deleteIndex,1)
                            this.dataFilesEdit.splice(this.deleteIndex,1)
                         break  
                }
                this.fileStatus[this.deleteTab].splice(this.deleteIndex,1)
            } else {
               this.fileStatus[this.deleteTab][this.deleteIndex] = 2
            }
        },
        getFileNamesClear(tab) {
            const _arr = []
            var source = this.programFileNames
            if (tab == 2) source = this.dataFileNames
            if (tab == 3) source = this.configFileNames
            for(let i = 0; i < source.length; i++) {
                if (this.fileStatus[tab][i] != 2) {
                    _arr.push({index: i, name: source[i]})
                }
            }
            return _arr
        },
        getResultColor(_index) {
            if (this.grade[_index] == 0 && this.vplExecutionInfo[_index] == '') return 'primary'
            if (this.grade[_index] == 0) return 'red'
            if (this.grade[_index] == 100) return 'green'
            return 'orange'
        },
/*        getCompilerColor(_index) {
            if (this.vplCompilerInfo[_index].lenght > 11) return 'red'
            if (this.vplCompilerInfo[_index] == '' && this.vplExecutionInfo[_index] == '') return 'primary'
            return 'green'
        },
 */       getSubmittedFiles(_index) {
            var _data = []
            var _res = []
            if (_index == 0) {
                _data = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_data !='')
                  _data = _data.files
            } else {
                _data = this.programFilesAuthoredEdit
            }
            for (let i=0; i<_data.length; i++) {
                if (this.fileStatus[1][i] != 2)
                if (_index == 1) {
                    _res.push( { filename: this.programFileNames[i],
                                filecontent: _data[i]
                    })
                } else {
                    _res.push( { filename: this.programFileNames[i],
                                filecontent: _data[i].aContent
                                })
                }
            }
            return _res
        },
        getKeepFiles(_index) {
            var _data = []
            var _res = []
            if (_index == 0) {
                _data = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_data !='')
                  _data = _data.filesToKeep
            } else {
                _data = this.dataFilesEdit
            }
            for (let i=0; i<_data.length; i++) {
                if (this.fileStatus[2][i] != 2)
                _res.push( { filename: this.dataFileNames[i],
                             filecontent: _data[i]
                })
            }
            return _res
        },
        getConfigFiles(_index) {
            var _data = []
            var _res = []
            if (_index == 0) {
                _data = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_data !='')
                  _data = _data.configFiles
            } else {
                _data = this.configFilesEdit
            }
            for (let i=0; i<_data.length; i++) {
                if (this.fileStatus[3][i] != 2)
                _res.push( { filename: this.configFileNames[i],
                             filecontent: _data[i]
                })
            }
            return _res
        },        
        runCode(_index, _exe_type) {
          if (this.isRunning[_index]) return
/*          this.vplProcessInfo[_index] = ''  
          this.vplCompilerInfo[_index] = ''  
          this.vplExecutionInfo[_index] = ''  
*/          const submitted_files = this.getSubmittedFiles(_index)
          const keep_files = this.getKeepFiles(_index)
          const config_files = this.getConfigFiles(_index)

          let data = {
              task_id: this.myContent.id,
              course_id: this.myContent.course_id,
              exe_type : _exe_type, // 0 - evaluate, 1 - interactive
              submitted_files: JSON.stringify(submitted_files),
              keep_files: JSON.stringify(keep_files),
              config_files: JSON.stringify(config_files),
              testCases: _index == 0 ? JSON.parse(this.myContent.languages[this.getShowTaskIndex].content).testCases : this.tmpTestCases
              // testCases: JSON.parse(this.myContent.languages[this.getShowTaskIndex].content).testCases
          }

          axios.post('/vpl-run-test3', data, this.$store.getters.getAxiosConfig )
          .then((res) => {              
            // pripravit tickety pre konzolu
            this.$store.commit('setSocketTickets', res.data)
            // resetovat vysledky
            // otvorit konzolu
            this.$store.commit('setStartConsole', _index+1)
            // this.readVPLAnswer(res.data, _index);
 
            this.isRunning[_index] = true
          })
          .catch(error => {
            this.$store.commit('setFeedback', error)
          })
        },
        setGrade() {
            // console.log('setujem')
            if (this.getConsoleGrade == null) return
            this.grade[this.getConsoleGrade.terminalIndex-1] = this.getConsoleGrade.grade
            this.isRunning[this.getConsoleGrade.terminalIndex-1] = false
            this.$store.commit('setConsoleGrade',null)
        }
/*        readVPLAnswer(tickets, _index) {
            this.showCompileInfo[_index] = false
            this.showExecuteInfo[_index] = false
           // var arr = []

            let monitoringTarget = configData.jailSocketConnection + tickets.monitorticket+'/monitor'
            let executionTarget = configData.jailRunSocketConnection + tickets.executionticket+'/execute'//configData.jailSocketConnection + '
//            let adminTarget = configData.jailRunSocketConnection + tickets.adminticket +'/admin'

            this.vplProcessInfo[_index] = 'awaiting connection... '
            this.$store.commit('setSocketMessageData','awaiting connection... ')

            this.monitoringSocket[_index] = new WebSocket(monitoringTarget)
            // this.$store.commit('setSocket',this.monitoringSocket[_index])

            this.monitoringSocket[_index].onopen = () => {
                    this.vplProcessInfo[_index] = "connected... " 
                    this.$store.commit('setSocketMessageData',"connected... ") 
                }

                this.monitoringSocket[_index].onmessage = ({data}) => {
                    if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                    this.vplProcessInfo[_index] = data 
                    this.$store.commit('setSocketMessageData',data)
                    if (data == 'run:terminal') {
                        this.$store.commit('setSocket',executionTarget)
                    }

                    if (data == 'retrieve:') { // compilation successfull, start running
                            let d = { adminticket: tickets.adminticket }
                            this.vplProcessInfo[_index] = 'reading result'
                            axios.post('/vpl-get-result', d, this.$store.getters.getAxiosConfig )
                            .then((res) => {
                                // set data to var
                                this.vplCompilerInfo[_index] = '<pre>' + res.data.compilation + '</pre>'
                                this.vplExecutionInfo[_index] = '<pre>' + res.data.execution + '</pre>'
                                this.vplProcessInfo[_index] = ''
                                if (res.data.compilation >'') this.showCompileInfo[_index] = true
                                else this.showExecuteInfo[_index] = true
                                let pos = res.data.execution.indexOf('Grade :=>>')
                                if (pos>-1) this.grade[_index] = res.data.execution.substring(pos+10).trim()
                                if (this.grade[_index] == '100') this.showExecuteInfo[_index] = false
                            })
                            .catch(error => {
                                this.vplProcessInfo[_index] = 'error ' + error
                                this.$store.commit('setFeedback', error)
                            })
                    }
                    if (data == 'close:') { 
                        this.isRunning[_index] = false 
                        this.vplProcessInfo[_index] = ''
                        this.monitoringSocket[_index].close()
                    }
                }
            
        }, */
    }
}
</script>

<style>

</style>

